import { combineReducers } from 'redux';
import { documentsReducer } from './Documents/reducer';
import { taxOrganizerReducer } from './TaxOrganizer/reducer';

export const rootReducer = combineReducers({
  documents: documentsReducer,
  taxOrganizer: taxOrganizerReducer,
});